import 'pages/loading/Loading.scss';

function Loading() {
  return (
    <div id="progress-turn">
      <div className="loader">
        <div className="inner one"></div>
        <div className="inner two"></div>
        <div className="inner three"></div>
      </div>
    </div>
  );
}

export default Loading;
